import React, { useEffect } from 'react'
import { Route } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import { useSelector } from 'react-redux'

import { AppStateType } from '@/store/rootReducer'
import Loading from '@/components/UI/Loading/Loading'
import MainLayout from '@/components/MainLayout/MainLayout'

const OneAuthWrapper = ({ Component, ...rest }: any) => {
  const windowObj: any = window
  const { history } = rest

  const { isLoggedIn } = useSelector((state: AppStateType) => {
    return state?.auth
  })

  useEffect(() => {
    // redirect if token and user is not logged in
    // if token is invalid then we have 401 setted up
    // that will logged out user and let user login again
    if (!isLoggedIn && !history.location.state) {
      const query = new URLSearchParams(history.location.search)
      let url =
        windowObj.REACT_APP_ONE_AUTH_DOMAIN +
        '/authorize?scope=openid%20profile%20email&response_type=code' +
        `&client_id=${windowObj.REACT_APP_ONE_AUTH_CLIENTID}` +
        `&redirect_uri=${window.location.origin + windowObj?.SUB_DOMAIN + '/'}` +
        `&nonce=${uuidv4()}` +
        `&state=${uuidv4()}`

      if (query.get('through') === 'lti' && query.get('_sid')) {
        // Check if this is for LTI, then include the lti params
        url += `&_sid=${query.get('_sid')}`
      }

      if (
        !history.location.search ||
        (!query.get('code') && !query.get('state'))
      ) {
        // store original path to redirect after login
        let originalPath = history.location.pathname
        const params = new URLSearchParams()
        if (query.get('agent')) {
          params.set('agent', query.get('agent'))
        }
        if (query.get('viewMode')) {
          params.set('viewMode', query.get('viewMode'))
        }
        const search = params.toString()
        if (search) originalPath += `?${search}`

        localStorage.setItem('originalPath', originalPath)
        window.location.href = url
      }
    }
  }, [])

  return (
    <Route
      exact
      {...rest}
      render={matchProps =>
        isLoggedIn ? (
          <MainLayout showSidebar={rest.isHeader}>
            <Component history={history} {...matchProps} />
          </MainLayout>
        ) : (
          <Loading />
        )
      }
    />
  )
}

export default OneAuthWrapper
